import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  navItems = [
    {
      label: 'Dashboard',
      icon: '../../../assets/icons/home.svg',
      active: '../../../assets/icons/home-active.svg',
    },
    {
      label: 'Membership',
      icon: '../../../assets/icons/membership.svg',
      active: '../../../assets/icons/membership-active.svg',
    },
    {
      label: 'Vault',
      icon: '../../../assets/icons/vault.svg',
      active: '../../../assets/icons/vault-active.svg',
    },
    {
      label: 'Relay',
      icon: '../../../assets/icons/relay.svg',
      active: '../../../assets/icons/relay-active.svg',
    },
    {
      label: 'API Keys',
      icon: '../../../assets/icons/key.svg',
      active: '../../../assets/icons/key-active.svg',
    },
    {
      label: 'Settings',
      icon: '../../../assets/icons/settings.svg',
      active: '../../../assets/icons/settings-active.svg',
    },
  ];
  activeItem = this.navItems[0].label;
  userData: any;
  isToggled: boolean = false;
  @Input() isMobileSideNav: boolean = false;
  @Output() toggleEvent = new EventEmitter<boolean>();
  constructor(
    private router: Router,
    private authService: AuthService,
    private notification: NzNotificationService
  ) {
    this.checkScreenWidth();
  }
  ngOnInit() {
    const currentUrl = this.router.url.slice(1); // Remove leading '/'
    const matchedItem = this.navItems.find((item) =>
      currentUrl.includes(this.formatString(item.label))
    );
    if (matchedItem) {
      this.activeItem = matchedItem.label;
    }
    const savedState = localStorage.getItem('isToggled');
    this.isToggled = savedState === 'true';
  }
  closeMobileSidenav = () => {
    this.isMobileSideNav = false;
    console.log('sidenav', this.isMobileSideNav);
  };
  openMobileSidenav = () => {
    this.isMobileSideNav = true;
  };
  setActiveItem(item: string) {
    console.log(item);
    this.activeItem = item;
    const url = this.formatString(item);
    this.router.navigate([`/${url}`]);
  }
  formatString(input: string) {
    return input.toLowerCase().replace(/\s+/g, '-');
  }
  getIcon(item: any): string {
    return this.activeItem === item.label ? item.active : item.icon;
  }
  toggleSideBar = () => {
    this.isToggled = !this.isToggled;
    this.toggleEvent.emit(this.isToggled);
    localStorage.setItem('isToggled', String(this.isToggled));
  };
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenWidth();
  }
  checkScreenWidth() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 800) {
      this.isToggled = true;
      this.toggleEvent.emit(this.isToggled);
      localStorage.setItem('isToggled', String(this.isToggled));
    } else {
      this.isToggled = false;
      this.toggleEvent.emit(this.isToggled);
    }
  }
  getData() {
    this.authService.me().subscribe({
      next: (res: any) => {
        this.userData = res;
      },
      error: (err) => {
        this.notification.error('Error', 'Failed to get user data', {
          nzClass: 'notification',
        });
      },
    });
  }
}
